import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import Papa from 'papaparse';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import PopupComponent from './PopupComponent';
import './App.css';

const colorSortValue = {
  '#FF5252': 1, // Red
  '#FFCA28': 2, // Yellow
  '#A5D6A7': 3, // Green
  'lightgrey': 4, // Grey
  // ... add other colors if needed
};

const colorCategorySortOrder = {
  'high': 1, // Red
  'medium': 2, // Yellow
  'low': 3, // Green
  'default': 4, // Grey
};

const getColorCategory = (colorCode) => {
  return colorMappings[colorCode] || 'default';
};

const getSortOrder = (colorCategory) => {
  return colorCategorySortOrder[colorCategory] || colorCategorySortOrder['default'];
};

function createComparatorForField(index) {
  return (valueA, valueB, nodeA, nodeB, isInverted) => {
    const colorCategoryField = `field_${index}_colorCategory`;
    const colorCategoryA = nodeA.data[colorCategoryField];
    const colorCategoryB = nodeB.data[colorCategoryField];

    const sortOrderA = getSortOrder(colorCategoryA);
    const sortOrderB = getSortOrder(colorCategoryB);
    return (sortOrderA - sortOrderB);
  };
}


// Define a map from conditions to colors
const colorMappings = {
  '#FF5252': 'high', // Red
  '#FFCA28': 'medium', // Yellow
  '#A5D6A7': 'low', // Green
  'lightgrey': 'default', // Grey
};

const determineCellColor = (value, data) => {
  if (value && typeof value === 'string' && value.includes('|')) {
  //const value = value; // This is the cell value
  let parts = value.split('#'); // This splits the string into an array on the '#' character
  let transactionCount = parts[1].trim();
  //console.log('params - ' + params)

    // Function to convert the value string into a percentage sum
  const calculateTotalPercentage = (valueString) => {
    if (valueString && typeof valueString === 'string' && valueString.includes('|')) {
      const parts = valueString.split('|').map(part => parseFloat(part.replace('%', '').trim()));
      if (parts.length === 2) {
        // Assuming there are always 2 parts, first part gets a weight of 25%, second part 75%
        return parts[0] * 0.25 + parts[1] * 1;
      }
    }
    return 0;
  };
  if (value && typeof value === 'string' && value.includes('|')) {
    const totalPercentage = calculateTotalPercentage(value);
    const calculatedTransactionCount = transactionCount;
    //console.log('transactionCount - '+transactionCount + ', value - '+value+ ', totalPercentage - '+totalPercentage+ ', calculatedTransactionCount - '+calculatedTransactionCount)
    if ((totalPercentage > 80 && calculatedTransactionCount < 100) ||
        (totalPercentage > 60 && calculatedTransactionCount < 500 && calculatedTransactionCount >= 100) ||
        (totalPercentage > 40 && calculatedTransactionCount < 1000 && calculatedTransactionCount >= 500) ||
        (totalPercentage > 20 && calculatedTransactionCount > 1000)) {
          console.log('totalPercentage --- ' + totalPercentage + 'transactionCount --- ' + transactionCount);
      return '#FF5252';
    } else if ((totalPercentage < 80 && totalPercentage > 60 && calculatedTransactionCount < 100) ||
              (totalPercentage < 60 && totalPercentage > 40 && calculatedTransactionCount < 500 && calculatedTransactionCount >= 100) ||
              (totalPercentage < 40 && totalPercentage > 20 && calculatedTransactionCount < 1000 && calculatedTransactionCount >= 500) ||
              (totalPercentage < 20 && totalPercentage > 15 && calculatedTransactionCount > 1000)) {
                console.log('totalPercentage --- ' + totalPercentage + 'transactionCount --- ' + transactionCount);
      return '#FFCA28';
    } else if ((totalPercentage > 40 && calculatedTransactionCount < 100) ||
              (totalPercentage < 40 && totalPercentage > 20 && calculatedTransactionCount < 500 && calculatedTransactionCount >= 100) ||
              (totalPercentage < 20 && totalPercentage > 15 && calculatedTransactionCount < 1000 && calculatedTransactionCount >= 500) ||
              (totalPercentage < 15 && calculatedTransactionCount > 1000)) {
      return '#A5D6A7';
    } else {

      return '#A5D6A7';
    }
  } else {
    return 'lightgrey';
  }
} else {
  return 'lightgrey';
}
};


class App extends React.Component {
  constructor(props) {
    super(props);
    //this.determineCellColor = this.determineCellColor.bind(this);
    this.state = {
      rowData: [],
      columnDefs: [],
      showPopup: false,
      popupData: {},
      startDate: this.getCurrentFormattedDate(), // State to store the start date
      endDate: this.getCurrentFormattedDate(), // State to store the end date
      selectedDataset: 'yesterday',
      gridReady: false,
    };
    this.gridRef = React.createRef();
    this.refreshInterval = null;
  }

  getCurrentFormattedDate() {
    const now = new Date();
    now.setDate(now.getDate() - 1);
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  colorToSortValue = {
    'red': 1,
    'yellow': 2,
    'green': 3,
    'grey': 4
  };

  // Define a map from colors to sortable values

  getCellStyle = (params) => {
    const color = determineCellColor(params.value, params.data);
    //console.log(params, color);
    params.data.colorSortValue = colorMappings[color] || 4;

    // Assuming you have a way to set the sortOrder on the node
    return {
        backgroundColor: color,
        textAlign: 'center',
        padding: '0px !important', // This should remove any padding within the cell
        overflow: 'hidden', // Prevent content from overflowing
        whiteSpace: 'nowrap', // Prevent content from wrapping
        textOverflow: 'ellipsis' // Add an ellipsis if the content is too long
    };

  };

  createColumnDef = (header, subHeader, index) => {
    let headerName = subHeader === null || typeof subHeader !== 'string' ? '' : subHeader.toUpperCase();
    let mainHeader = header=== null || typeof header !== 'string' ? '' : header.toUpperCase();

    let width = index === 0 ? 250 : 100; // Assuming you want the first column to be 200px wide
    let minWidth = index === 0 ? 250 : 100; // You can adjust this value as needed


    const merchantColumnStyle = {
      backgroundColor: '#f0f0f0', // example background color
      fontWeight: 'bold', // make text bold
    };

    let columnDef = {
      headerName: headerName,
      mainHeader: mainHeader,
      filter: false,
      cellStyle: (params) => {
        // Obtain the original value before processing by valueGetter
        const originalValue = params.data[`field_${index}`];
        const color = determineCellColor(originalValue, params.data); // Pass the original value to determineCellColor
        return {
          backgroundColor: color,
        };
      },
      //filter: 'agTextColumnFilter', // Use the text filter
      valueGetter: (params) => {
        const value = params.data[`field_${index}`];

        if (value && typeof value === 'string' && value.includes('|')) {
          const parts = value.split('#'); // Split the string by '#'
          if (parts.length > 0) {
            const percentage = parts[0]; // Take the first part before '#'
            return percentage.trim(); // Return the trimmed percentage part
          }
        }
        return value; // Return the original value if it's not a string or if split operation didn't work as expected
      },

      filterValueGetter: (params) => {
        //console.log('_colorCategory -- > ' + params.data[`field_${index}_colorCategory`])
        return params.data[`field_${index}_colorCategory`]; // Return the color category for filtering
      },
      width: width, // Use the variable we set above
      minWidth: minWidth, // Use the variable we set above
      //minWidth: 100,
      //maxWidth: 100,
      resizable: true,
      field: `field_${index}`,
      comparator: createComparatorForField(index),

    };

    if (index === 0) { // Assuming index 1 corresponds to the Merchant column
      columnDef.minWidth = 300; // Set your desired width here
      columnDef.maxWidth = 400;
      columnDef.resizable = true; // Optional: if you want to allow resizing
      columnDef.cellStyle = merchantColumnStyle;
    }

    return columnDef;
  }


  componentDidMount() {
    this.fetchData();
  }

  handleDateChange = (event) => {
    this.setState({ [event.target.name]: event.target.value }, () => {
      //console.log("Updated Date:", this.state.startDate, this.state.endDate); // Debugging
    });
  };

  fetchData = () => {
    const { startDate, endDate } = this.state;
    const currentDate = this.getCurrentFormattedDate();

    let apiEndpoint;
    if (startDate === currentDate && endDate === currentDate) {
      // Use the endpoint for the current date
      //apiEndpoint = `http://192.168.0.170/api/flask/report/datareal?start=${startDate}&end=${endDate}`;
      apiEndpoint = `http://192.168.0.170/api/flask/report/datareal?start=${startDate}&end=${endDate}`;
    } else {
      // Use the regular endpoint for other dates
      apiEndpoint = `http://192.168.0.170/api/flask/report/data?start=${startDate}&end=${endDate}`;
    }
    fetch(apiEndpoint)
      .then(response => response.text())
      .then(csvRawData => {
        Papa.parse(csvRawData, {
          header: false, // Set this to true if your CSV has headers
          dynamicTyping: true,
          skipEmptyLines: true,
          complete: (result) => {
            this.processData(result.data);
          }
        });
      })
      .catch(error => console.error('Error fetching CSV:', error));
  };

  processData = (csvData) => {
    let [firstRow, secondRow, ...dataRows] = csvData;
    // Convert the first and second row elements to uppercase
    firstRow = firstRow.map(element => typeof element === 'string' ? element.toUpperCase() : element);
    secondRow = secondRow.map(element => typeof element === 'string' ? element.toUpperCase() : element);

    // Initialize an array to hold the column definitions
    const columnGroups = [];
    let currentGroupHeader = firstRow[0];
    let currentGroupChildren = [];

    // Process the first row to determine column groups
    firstRow.forEach((header, index) => {
      //if (index === 0) return; // Skip the first column
      if (header === currentGroupHeader) {
        // Add this column to the current group
        currentGroupChildren.push(this.createColumnDef(header, secondRow[index], index));
      } else {
        // Finalize the previous group and start a new one
        columnGroups.push({
          headerName: currentGroupHeader,
          children: currentGroupChildren
        });
        currentGroupHeader = header;
        currentGroupChildren = [this.createColumnDef(header, secondRow[index], index)];
      }
    });

    // Push the last group if it exists
    if (currentGroupChildren.length > 0) {
      columnGroups.push({
        headerName: currentGroupHeader,
        children: currentGroupChildren
      });
    }

    dataRows.splice(0, 1);
    // Process the rows to match the new field keys
    const processedRows = dataRows.map((row) => {
      let newRow = {}; // New object to accumulate data and colorValue

      row.forEach((value, index) => {
        const fieldKey = `field_${index}`;
        newRow[fieldKey] = value;

        // Determine the color and color category for this cell
        const colorCode = determineCellColor(value, row);
        const colorCategory = getColorCategory(colorCode);

        // Set the colorCategory for this cell
        newRow[`${fieldKey}_colorCategory`] = colorCategory;

        // Set styles based on the color
        const style = this.getCellStyle({ value, data: newRow });
        newRow.colorValue = colorSortValue[style.backgroundColor] || 5;
      });

      return newRow; // Return the new object for each row
    });


    if (columnGroups.length > 0) {
      // Get the last group
      const lastGroup = columnGroups[columnGroups.length - 1];

      if (lastGroup.children && lastGroup.children.length >= 1) {
        // Hide the second child column of the last group
        lastGroup.children[0].hide = true; // Index 1 is the second item
      }

      // Check if the last group has at least two children (columns)
      if (lastGroup.children && lastGroup.children.length >= 2) {
        // Hide the second child column of the last group
        lastGroup.children[1].hide = true; // Index 1 is the second item
      }
    }

    this.setState({
      columnDefs: columnGroups,
      rowData: processedRows,
    });
  };


  onCellClicked = (event) => {
    if (event.value !== undefined && event.value !== null) {
      const originalValue = event.data[`field_${event.column.colId.split('_')[1]}`];

      // Split the original value to get transactionCount
      const parts = originalValue.split('#');
      const transactionCount = parts.length > 1 ? parts[1].trim() : null;

      this.setState({
        showPopup: true,
        popupData: {
          value: event.value,
          header: event.colDef.headerName,
          mainHeader: event.colDef.mainHeader,
          merchant: event.data['field_0'],
          acqBank: event.colDef.mainHeader,
          startDate: this.state.startDate, // Add startDate from the state
          endDate: this.state.endDate, // Add endDate from the state
          tenderMode: event.colDef.headerName,
          combinedValue: event.data['field_1'] + '##' + event.colDef.mainHeader + '##' + event.colDef.headerName,
          transactionCount: transactionCount,
          colHeader: event.data['field_0']
        }
      });
    }
  };

  onGridReady = (params) => {
    this.setState({ gridReady: true });
    // ... additional logic if needed
  };

  closePopup = () => {
    this.setState({ showPopup: false });
  };

  render() {
    const { showPopup, popupData, startDate, endDate } = this.state;

    //console.log('Render method called. Show Popup:', showPopup);

    return (
      <div className="ag-theme-alpine custom-grid" style={{ height: '95vh', width: '100%' }}>
        <div style={{ marginBottom: '20px' }}>
          <label>Start Date:</label>
          <input
            type="date"
            name="startDate"
            value={startDate}
            onChange={this.handleDateChange}
          />
          <label>End Date:</label>
          <input
            type="date"
            name="endDate"
            value={endDate}
            onChange={this.handleDateChange}
          />
          <button onClick={this.fetchData}>Fetch Data</button>
        </div>
        <div></div>
        <AgGridReact
          ref={this.gridRef}
          rowData={this.state.rowData}
          columnDefs={this.state.columnDefs}
          onGridReady={this.onGridReady}

          defaultColDef={{
            resizable: true,
            filter: true,
            floatingFilter: true,
            sortable: true
          }}
          onCellClicked={this.onCellClicked}
        />
        {showPopup && <PopupComponent data={popupData} onClose={this.closePopup} />}
        
      </div>
    );
  }
}

export default App;